import { Button } from "primereact/button";
import React, { useEffect, useState } from "react";
import { useParams, useHistory } from "react-router-dom";

export const ConfirmRegisterMessagePage = () => {    
    
    const initDataConfirmRegisterMessage = {
        isSuccess: false,
        tokenVerificationData: {}
    };

    const { token } = useParams();
    let history = useHistory();    
    const [confirmRegisterMessage, setConfirmRegisterMessage] = useState(initDataConfirmRegisterMessage);

    useEffect(function() {        
        console.log("path param", token);  
        let url = `https://springboot-widy-app.widyan123.site/widy-app/user-confirmation/token-verification/${token}`;
        const requestPayload = {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Access-Control-Allow-Origin': '*'
            }
        }
        fetch(url, requestPayload)
        .then((res) => {
            console.log('HTTP ', res.status);
            return res.json().then(
              (body) => ({
                httpStatus: res.status,
                body,
              })
            );
          })
          .then(({ httpStatus, body }) => {
            if (httpStatus >= 400 && httpStatus <= 599) {
              console.error('Error response:', httpStatus, body);
              return Promise.reject(body);
            } else {
              console.log('Successful response:', body);              
              setConfirmRegisterMessage({isSuccess: true, tokenVerificationData: body});
            }
          })
          .catch((error) => {
            console.error('Request failed:', error);
            setConfirmRegisterMessage({isSuccess: false, tokenVerificationData: error});
          });     
    }, []);

    function clickLogin(event) {
        event.preventDefault();
        history.push('/login');
    }

    if(confirmRegisterMessage.isSuccess) {
        return (        
            <div className="grid">
                <div className="col-12">
                    <div className="card">
                        <h5>Confirm Register Sukses!</h5>
                        <p>{confirmRegisterMessage.tokenVerificationData.message}</p>                    
                            <Button label="Login" onClick={clickLogin} className="p-button-link mb-2 mr-2"></Button>                    
                    </div>
                </div>
            </div>
        )
    } else {
        return (        
            <div className="grid">
                <div className="col-12">
                    <div className="card">
                        <h5>Confirm Register Gagal!</h5>
                        <p>{confirmRegisterMessage.tokenVerificationData.message}</p>                                           
                    </div>
                </div>
            </div>
        ) 
    }
}